import React, { useEffect } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import moment from "moment";
import HelperText from "../partials/HelperText";


const MonthRange = ({ dateValue, setDateValue, index, showYear, noError, setDateErrorStatus, ...props }) => {
  const [error, setError] = React.useState(['', ''])
  const [cleared, setCleared] = React.useState(false);

  // if (setDateErrorStatus) {
  //   if (error[0] != '' || error[1] != '') setDateErrorStatus(true)
  //   if (error[0] == '' && error[1] == '') setDateErrorStatus(false)
  // }
  useEffect(() => {
    if (setDateErrorStatus) {
      const hasError = error[0] !== '' || error[1] !== '';
      setDateErrorStatus(hasError);
    }
  }, [error]);


  useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    return () => { };
  }, [cleared]);


  const date = moment();

  
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        //  open={open}
        inputFormat={showYear ? 'DD/MM/YYYY' : "DD MMMM"}
        mask={"__/__/____"}
        // minDate={'2021-04-05'}
        // maxDate={index === 0 && dateValue[1] ? dateValue[1] : date}
        defaultValue={null}
        value={dateValue[index]}
        onChange={(newValue) => {
          // console.log(newValue)
          setError(['', ''])
          let arrCopy = [...dateValue]
          arrCopy[index] = newValue
          if (arrCopy[0] && arrCopy[1]) {
            if (!arrCopy[0].isBefore(arrCopy[1])) {
              let newError = ['', '']
              const errorMessage = ['Cannot select a higher date', 'Cannot select a lesser date']
              newError[index] = errorMessage[index]
              setError(newError)
              return
            }
          }
          setDateValue((prev) => ({
            ...prev,
            dateValue: arrCopy
          }));
        }}
        slotProps={{
          field: { clearable: true, onClear: () => setCleared(true) },
          // textField: {
          //   helperText: 'Cannot select a higher month',
          // },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="DD/MM/YYY"
            size="small"
            sx={{
              fontSize: "14px",

              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  textTransform: "uppercase",
                  borderColor: "grey.border40",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              },
            }}
            helperText={error[index] && !noError && <HelperText text={error[index]} />}
          />
        )}
        // onError={(newError) => setError(newError)}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default MonthRange;
